import AlphaModuleManager from '../abstracts/classes/alpha-module-manager'
import AlphaNotifier from '../abstracts/classes/alpha-notifier'

document.addEventListener('DOMContentLoaded', () => {
  // don't initialize Alpha multiple times
  if (typeof window.alpha === 'undefined') {
    window.alpha = new AlphaModuleManager()
    window.alpha.init()
  }

  if (typeof window.alphaNotifier === 'undefined') {
    window.alphaNotifier = new AlphaNotifier()
    window.alphaNotifier.init()
  }
})
